import React, { useState } from 'react';
import { http } from '../lib/http';
import { useNavigate } from 'react-router-dom';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    setError('');
    setLoading(true);

    try {
      const data = await http.post('/api/auth/forgot-password', { email });
      setStatus(data.message || 'If that email exists, a reset link has been sent.');
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
    <div className="auth-header">
      <div className="brand" onClick={() => navigate("/")}>
      <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
      <span className="brand-text">CUSTOM ROAM</span>
     </div>
      <div className="back-home" onClick={() => navigate('/')}>
       Back to Home
     </div>
      </div>
    <div className="forgot-password-container">
      <h2>Forgot Password</h2>
      <p>Enter your registered email to receive a password reset link.</p>

      <form onSubmit={handleSubmit} className="forgot-password-form">
        <input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="forgot-input"
        />
        <button type="submit" disabled={loading} className="forgot-button">
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>

      {status && <p className="forgot-success">{status}</p>}
      {error && <p className="forgot-error">{error}</p>}

      <p className="back-login" onClick={() => navigate('/login')}>
        ← Back to Login
      </p>
    </div>
    </div>
  );
};

export default ForgotPasswordPage;
